import { useHandler } from "@redotech/react-util/hook";
import { RedoTextInput } from "@redotech/redo-web/arbiter-components/input/redo-text-input";
import {
  RedoModal,
  RedoModalProps,
} from "@redotech/redo-web/arbiter-components/modal/redo-modal";
import { Flex } from "@redotech/redo-web/flex";
import { Text } from "@redotech/redo-web/text";
import { memo, useState } from "react";

export const PinVerificationModal = memo(function PinVerificationModal({
  expectedPin,
  onClose,
  onSuccess,
  isOpen,
  title = "PIN Verification Required",
  description = "Please enter your 4-digit PIN to proceed with this action.",
}: {
  expectedPin: string;
  onClose: () => void;
  onSuccess: () => void;
  isOpen: boolean;
  title?: string;
  description?: string;
}) {
  const [pin, setPin] = useState("");
  const [error, setError] = useState("");

  const handleVerify = useHandler(() => {
    if (pin === expectedPin) {
      onSuccess();
    } else {
      setError("Incorrect PIN. Please try again.");
      setPin("");
    }
  });

  const modalProps: RedoModalProps = {
    title,
    theme: "neutral",
    modalSize: "sm",
    isOpen,
    primaryButton: {
      text: "Verify pin",
      onClick: handleVerify,
      disabled: pin.length !== 4,
    },
    secondaryButton: { text: "Cancel", onClick: onClose },
    onModalCloseRequested: onClose,
  };

  return (
    <RedoModal {...modalProps}>
      <Flex dir="column" gap="lg">
        <Text fontSize="sm" textColor="secondary">
          {description}
        </Text>
        <Flex dir="column" gap="md">
          <RedoTextInput
            autoFocus
            htmlPattern="[0-9]*"
            inputTypeHint="password"
            label="4-digit PIN"
            maxLength={4}
            placeholder="Enter PIN"
            setValue={setPin}
            state={error ? "error" : "default"}
            value={pin}
          />
          {error && (
            <Text fontSize="sm" textColor="error">
              {error}
            </Text>
          )}
        </Flex>
      </Flex>
    </RedoModal>
  );
});
